export { D as DynamicYieldScript } from '../../chunks/component-BcgmQevS.js';
import 'react/jsx-runtime';
import 'next/script';
import 'react';

const DYNAMIC_YIELD_CONTEXT_TYPE_HOMEPAGE = 'HOMEPAGE';
const DYNAMIC_YIELD_CONTEXT_TYPE_PRODUCT = 'PRODUCT';
const DYNAMIC_YIELD_CONTEXT_TYPE_CATEGORY = 'CATEGORY';
const DYNAMIC_YIELD_CONTEXT_TYPE_OTHER = 'OTHER';

const setDynamicYieldContext = (context) => {
    const { DY } = window;
    if (!DY) {
        return;
    }
    DY.recommendationContext = context;
};
const trackLoginUser = (userId) => {
    const { DY } = window;
    if (!DY) {
        return;
    }
    DY.API('event', {
        name: 'Identify',
        properties: {
            dyType: 'identify-v1',
            cuid: userId,
            cuidType: 'userID',
        },
    });
};
const trackFirstLoginUser = (userId) => {
    const { DY } = window;
    if (!DY) {
        return;
    }
    DY.API('event', {
        name: 'Login',
        properties: {
            dyType: 'login-v1',
            cuid: userId,
            cuidType: 'userID',
        },
    });
};
const createSmartObject = (smartObjectId, target, config) => {
    const { DYO } = window;
    if (!DYO) {
        return;
    }
    const afterRenderCallback = config?.afterRenderCallback
        ?? function callback() { };
    DYO.smartObject(smartObjectId, {
        target,
        inline: config?.inline ?? true,
        afterRenderCallback,
    });
};

export { DYNAMIC_YIELD_CONTEXT_TYPE_CATEGORY, DYNAMIC_YIELD_CONTEXT_TYPE_HOMEPAGE, DYNAMIC_YIELD_CONTEXT_TYPE_OTHER, DYNAMIC_YIELD_CONTEXT_TYPE_PRODUCT, createSmartObject, setDynamicYieldContext, trackFirstLoginUser, trackLoginUser };
//# sourceMappingURL=index.js.map
